import { useQuery } from "@tanstack/react-query";
import useMutationWithInvalidation from "neetocommons/react-utils/useMutationWithInvalidation";

import ipRestrictionApi from "../../apis/ip_restriction";
import { QUERY_KEYS } from "../../constants";

const { IP_RESTRICTION, ALLOWED_IP_RANGES } = QUERY_KEYS;

const useShowIpRestriction = () =>
  useQuery({
    queryKey: [IP_RESTRICTION],
    queryFn: () => ipRestrictionApi.show(),
  });

const useUpdateIpRestriction = () =>
  useMutationWithInvalidation(ipRestrictionApi.update, {
    keysToInvalidate: [[IP_RESTRICTION], [ALLOWED_IP_RANGES]],
  });

export { useShowIpRestriction, useUpdateIpRestriction };
